// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3f8Xa","title":"InfoRow_title__1Ns92"};